function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M21.4,20H10.6c-0.6,0-1.1-0.3-1.4-0.8c-0.3-0.5-0.2-1.1,0.1-1.6l0.6-0.8c0.8-1.3,1.3-2.7,1.3-4.2c0-2,1.3-3.8,3.1-4.6 C14.6,7.3,15.3,7,16,7s1.4,0.3,1.8,0.9c1.9,0.7,3.1,2.6,3.1,4.6c0,1.5,0.4,3,1.3,4.2l0.6,0.8c0,0,0,0,0,0c0.3,0.5,0.4,1.1,0.1,1.6 C22.5,19.7,22,20,21.4,20z M21.1,18.7C21.1,18.7,21.1,18.7,21.1,18.7L21.1,18.7z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M7.3,12c-0.2,0-0.3,0-0.5-0.1l-3.5-2C2.9,9.6,2.7,9,3,8.5C3.3,8,3.9,7.9,4.4,8.1l3.5,2c0.5,0.3,0.6,0.9,0.4,1.4 C8,11.8,7.7,12,7.3,12z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M6,17H2c-0.6,0-1-0.4-1-1s0.4-1,1-1h4c0.6,0,1,0.4,1,1S6.6,17,6,17z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M3.9,24c-0.3,0-0.7-0.2-0.9-0.5c-0.3-0.5-0.1-1.1,0.4-1.4l3.5-2c0.5-0.3,1.1-0.1,1.4,0.4c0.3,0.5,0.1,1.1-0.4,1.4l-3.5,2 C4.2,24,4,24,3.9,24z"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M28.1,24c-0.2,0-0.3,0-0.5-0.1l-3.5-2c-0.5-0.3-0.6-0.9-0.4-1.4c0.3-0.5,0.9-0.6,1.4-0.4l3.5,2c0.5,0.3,0.6,0.9,0.4,1.4 C28.8,23.8,28.5,24,28.1,24z"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M30,17h-4c-0.6,0-1-0.4-1-1s0.4-1,1-1h4c0.6,0,1,0.4,1,1S30.6,17,30,17z"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M24.7,12c-0.3,0-0.7-0.2-0.9-0.5c-0.3-0.5-0.1-1.1,0.4-1.4l3.5-2C28.1,7.9,28.7,8,29,8.5c0.3,0.5,0.1,1.1-0.4,1.4l-3.5,2 C25,12,24.8,12,24.7,12z"
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6,21c0.7,1.2,2,2,3.4,2s2.7-0.8,3.4-2H12.6z"
});

function SvgAlarmBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmBell);
export default __webpack_public_path__ + "static/media/alarmBell.74a99aa8.svg";
export { ForwardRef as ReactComponent };